import { Calendar } from '@fullcalendar/core';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';

import dayGridPlugin from '@fullcalendar/daygrid';
//import listPlugin from '@fullcalendar/list';

import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import timeGridPlugin from '@fullcalendar/timegrid';


const calendarEl = document.getElementById('calendar');




jQuery(function ($){
    //let Draggable = Calendar.Draggable;
    let containerEl = document.getElementById('external-events');
    if(containerEl){
        new Draggable(containerEl, {
            itemSelector: '.fc-event',
            eventData: function(eventEl) {
                return {
                    title: eventEl.innerText
                };
            }
        });


        const calendar = new Calendar(calendarEl, {


            //initialView: 'timeGridWeek',
            initialView: 'timeGridWeek',
            editable: false , //true
            //resources : projects_ressources,
            //plugins: [ dayGridPlugin, listPlugin, dayGridPlugin,timeGridPlugin, interactionPlugin],
            plugins: [  timeGridPlugin, interactionPlugin,resourceTimelinePlugin], // ,
            events: jsdata.events,
            resources: jsdata.event_sources,
            locale: 'fr',
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'resourceTimeline,timeGridWeek,timeGridDay' // dayGridDay,dayGridWeek,dayGridMonth , resourceTimeline
            },
            buttonText: {
                today:    'Aujourd\'hui',
                month:    'Par mois',
                week:     'Semaine',
                day:      'Jour',
                //list:     'Liste',
                resourceTimeline: 'Vue enquêteurs',
                // resourceTimelineYear: 'Par année'
            },
            defaultTimedEventDuration: jsdata.default_duration_formated,
            dateClick: function(info) {
                console.log(info);
            },
            droppable: false, // this allows things to be dropped onto the calendar
            drop: function(info) {
                pwk_update_event(info);
                info.draggedEl.parentNode.removeChild(info.draggedEl);
            },
            eventDragStop: function (info){
                pwk_update_event(info);
            },
            eventResize: function (info){
                alert("eventResizeStop : "+info.event.end);
                pwk_update_event(info);
            },
            eventOverlap: function(stillEvent, movingEvent) {
                console.log(stillEvent);
                console.log(movingEvent);
                return stillEvent.overlap && movingEvent.overlap;
            }


        })
        calendar.render()

    }





    function pwk_update_event(info){
        $.ajax(jsdata.ajax_url, {
            method: "POST",
            data:{
                action: "pwk_update_event",
                datas: {
                    id: info.event.id,
                    start: info.event.startStr,
                    end: info.event.endStr
                }
            },
            complete: function(e){
                console.log(e);
            }
        });
    }

    $('[data-resume]').on("click", function (e){
        e.preventDefault();
        let elt = $(this);
        console.log(elt)
        elt.prop('disabled', true);
        $.ajax(jsdata.ajax_url, {
            method: "POST",
            data:{
                action: "pwk_resume_itw",
                id: elt.data('resume'),
                prompt: $("#prompt").val()
            },
            complete: function(e){
                elt.prop('disabled', false);
                console.log(e);
            },
            success: function (e) {
                console.log(e)
                $("#resume_itw").remove().after(e.message);
                window.location.reload();
            }
        });
    });


    let dataTable = new DataTable('#table-entretien', {
        fixedHeader: true,
        layout: {
            topStart: {
                pageLength: {
                    menu: [25, 50, 100, 200]
                }
            }
        },
        language: {
            url: '//cdn.datatables.net/plug-ins/2.1.5/i18n/fr-FR.json',
        },
    });
});


